import React, { Component } from 'react'
import Link from 'next/link'
import { connect } from 'react-redux'
import { MenuOutlined } from '@ant-design/icons'
import { Menu, Tooltip, Row, Col, Badge } from 'antd'
import { withTranslation } from 'react-i18next'
import { CATALOG_ROUTES } from '../../constants/CatalogRoutes'
import { PERMISSIONS, ROLES } from '../../constants/AuthConstants'
import {
  downloadPricesList,
  setShowPricesListModal,
  clearSearchProduct,
  clearSegments,
  getNewsForFavorites,
  toggleShowBadge,
} from '../../actions'
import { getRolename, hasAccess } from '../../lib/AuthUtils'
import PricesListModal from './download-prices-list-modal'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { testingEnabledUsers },
} = getConfig()

function getItem(label, key, children, icon) {
  return {
    key,
    icon,
    children,
    label,
  }
}

class CatalogNavBar extends Component {
  handleClick = (e) => {
    switch (e.key) {
      case 'catalog':
        break

      default:
        break
    }
  }

  componentDidMount() {
    const { roleName } = this.props
    if (roleName === 'cliente' || roleName === 'vendedor') {
      this.props.getNewsForFavorites()
    }
  }

  componentWillUnmount() {
    // Cancel subscription
    if (this.props.getNewsForFavorites.cancel) {
      this.props.getNewsForFavorites.cancel()
    }
  }

  handleCatalogClick = () => {
    this.props.clearSegments()
    this.props.clearSearchProduct()
  }

  handleBadgeClick = () => {
    this.props.toggleShowBadge()
  }

  handleDownloadListPrices = () => {
    this.props.setShowPricesListModal()
  }

  getMenuItems() {
    const { user, roleName, t, favoritesBadgeFlag, prodWithDiff } = this.props

    const items = [
      hasAccess(user, [PERMISSIONS.PAGE.ADMIN]) &&
        getItem(
          <Link href={CATALOG_ROUTES.ADMIN}>
            <a>{t('Administrator')}</a>
          </Link>,
          'admin',
        ),
      hasAccess(user, [PERMISSIONS.PAGE.CATALOGO]) &&
        getItem(t('Catalog'), 'catalog', [
          getItem(
            <Link href={CATALOG_ROUTES.CATALOG}>
              <a onClick={this.handleCatalogClick}>{t('viewCatalog')}</a>
            </Link>,
            'viewCatalog',
          ),
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_DEALS]) &&
            getItem(
              <Link href={'/catalog/deal'}>
                <a data-testid='deals-page'>{t('Deals')}</a>
              </Link>,
              'deals',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.DOWNLOAD_PRICE_LIST]) &&
            getItem(
              <a onClick={this.handleDownloadListPrices} data-testid='priceList'>
                {t('Price list')}
              </a>,
              'priceList',
            ),
          (testingEnabledUsers?.includes(user.id) ?? false) &&
            hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_DISCOUNTS]) &&
            getItem(
              <Link href={'/catalog/discounts'}>
                <a data-testid='client-discounts-page'>{t('Discounts')}</a>
              </Link>,
              'clientDiscounts',
            ),
        ]),
      (hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_CURRENT_ACCOUNTS]) ||
        roleName === ROLES.REPORT) &&
        getItem(t('Current Accounts'), 'currentAccount', [
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_CURRENT_ACCOUNTS]) &&
            getItem(
              <Link href={CATALOG_ROUTES.CURRENT_ACCOUNT} data-testid='current-account-button'>
                {t('currentAccount.BALANCE_INQUIRY')}
              </Link>,
              'account',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.CREDIT_LIMIT]) &&
            getItem(
              <Link href={'/current-account/creditLimit'}>
                <a>{t('currentAccount.CREDIT_LIMIT')}</a>
              </Link>,
              'creditLimit',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.PROVISIONAL_RECEIPTS]) &&
            getItem(
              <Link href={'/provisionalReceipts'}>
                <a>{t('currentAccount.PROVISIONAL_RECEIPTS')}</a>
              </Link>,
              'receipts',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.PROVISIONAL_RECEIPTS_FOR_CLIENTS]) &&
            getItem(
              <Link href={'/current-account/clientProvisionalReceipts'}>
                <a>{t('provisionalReceipts.CLIENT_RECEIPTS')}</a>
              </Link>,
              'clientReceipts',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.BILLING_DETAIL]) &&
            getItem(
              <Link href={'/billingDetail'}>
                <a>{t('currentAccount.BILLING_DETAIL')}</a>
              </Link>,
              'billingDetail',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.AVERAGE_PAYMENT_DAYS]) &&
            getItem(
              <Link href={'/current-account/averagePaymentDays'}>
                <a>{t('currentAccount.AVERAGE_PAYMENT_DAYS')}</a>
              </Link>,
              'averagePaymentDays',
            ),
        ]),
      ((roleName === ROLES.SALESMAN && user.vendedor.tipovendedor !== 't') ||
        roleName === ROLES.ADMIN) &&
        getItem(t('financialManagement'), 'financialManagement', [
          getItem(
            <Link href={'/accountForms'}>
              <a data-testid='account-openings'>{t('ACCOUNT_OPENINGS.TITLE')}</a>
            </Link>,
            'opening_account',
          ),
          getItem(t('INVOICE.CREDIT_NOTE'), 'creditNote', [
            getItem(
              <Link href={'/invoices'}>
                <a>{t('INVOICE.REQUESTS')}</a>
              </Link>,
              'invoices',
            ),
          ]),
        ]),
      (hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_ORDERS]) ||
        hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_QUOTATIONS]) ||
        hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_STATISTICS]) ||
        hasAccess(user, [PERMISSIONS.PAGE.APPOINTMENTS]) ||
        hasAccess(user, [PERMISSIONS.PAGE.DASHBOARD]) ||
        hasAccess(user, [PERMISSIONS.PAGE.MY_CLIENTS])) &&
        getItem(t('My Account'), 'myAccount', [
          (roleName === ROLES.CLIENT || roleName === ROLES.SALESMAN) &&
            getItem(
              <Link href={'/cart'}>
                <a>{t('Cart')}</a>
              </Link>,
              'cart',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_QUOTATIONS]) &&
            getItem(
              <Link href={'/catalog/quotations'}>
                <a>{t('Quotations')}</a>
              </Link>,
              'quotations',
            ),
            roleName === ROLES.SALESMAN &&
            user.supervisor === true &&
            getItem(
              <Link href={'/dashboard'}>
                <a>{t('DASHBOARD')}</a>
              </Link>,
              'dashboard',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_STATISTICS]) &&
            getItem(<a href={CATALOG_ROUTES.STATISTICS}>{t('Statistics')}</a>, 'stats'),
          (roleName === ROLES.SALESMAN || roleName === ROLES.COLLECTOR) &&
          getItem(
              <Link href={'/my-clients'}>
                <a data-testid='my-clients'>{t('My clients')}</a>
              </Link>,
              'myClients',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.APPOINTMENTS]) &&
            getItem(
              <Link href={'/appointments'}>
                <a data-testid='appointments'>{t('Appointments')}</a>
              </Link>,
              'appointments',
            ),
          hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_ORDERS]) &&
          getItem(
              <Link href={'/catalog/orders'}>
                <a>{t('Orders')}</a>
              </Link>,
              'orders',
            ),
            (hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_STATISTICS]) ||
              hasAccess(user, [PERMISSIONS.PAGE.APPOINTMENTS]) ||
              hasAccess(user, [PERMISSIONS.PAGE.ADMIN])) &&
              getItem(t('Visits'), 'visits', [
                hasAccess(user, [PERMISSIONS.PAGE.CATALOGO_STATISTICS]) &&
                  getItem(
                    <Link href={CATALOG_ROUTES.STATISTICS}>
                      <a>{t('Statistics')}</a>
                    </Link>,
                    'stats',
                  ),
                hasAccess(user, [PERMISSIONS.PAGE.APPOINTMENTS]) &&
                  getItem(
                    <Link href={'/appointments'}>
                      <a data-testid='appointments'>{t('Appointments')}</a>
                    </Link>,
                    'appointments',
                  ),
                hasAccess(user, [PERMISSIONS.PAGE.ADMIN]) &&
                  getItem(
                    <Link href={CATALOG_ROUTES.APPOINTMENTS_STATISTICS}>
                      <a>{t('appointmentsStatistics')}</a>
                    </Link>,
                    'appointmentsStatistics',
                  ),
              ]),
          ]),
      hasAccess(user, [PERMISSIONS.PAGE.FAVORITE]) &&
        getItem(
          <Link href={'/favorites'}>
            <a onClick={this.handleBadgeClick}>
              {t('FAVORITE.FAVORITES')}
              {favoritesBadgeFlag && prodWithDiff.existDifferences ? (
                <Tooltip title={t('Some of your favourite products have news')} placement='top'>
                  <Badge count={'!'} offset={[5, -3]}></Badge>
                </Tooltip>
              ) : null}
            </a>
          </Link>,
          'favorite',
        ),
    ].filter(Boolean) // Filter false boolean values

    return items
  }

  render() {
    const { showPricesListModal } = this.props

    return (
      <div className='catalog-nav-bar hidden-print'>
        <Row>
          <Col span={24}>
            <Menu
              onClick={this.handleClick}
              mode='horizontal'
              overflowedIndicator={
                <MenuOutlined style={{ fontSize: '18px', verticalAlign: 'text-bottom' }} />
              }
              className='catalog-nav-bar-menu'
              items={this.getMenuItems()}
            />
          </Col>
        </Row>
        {showPricesListModal && <PricesListModal isModalOpen={showPricesListModal} />}
      </div>
    )
  }
}

const mapStateToProps = ({ auth, catalog }) => {
  const roleName = getRolename(auth)
  const user = auth.user ? auth.user : null
  const showPricesListModal = catalog.showPricesListModal
  const { favoritesBadgeFlag, catalogSegment } = catalog
  return {
    user,
    roleName,
    showPricesListModal,
    catalogSegment,
    favoritesBadgeFlag,
    prodWithDiff: catalog.productsWithDifferences,
  }
}

const mapDispatchToProps = (dispatch) => ({
  downloadPricesList: () => {
    dispatch(downloadPricesList())
  },
  setShowPricesListModal: () => {
    dispatch(setShowPricesListModal())
  },
  clearSearchProduct: () => {
    dispatch(clearSearchProduct())
  },
  clearSegments: () => {
    dispatch(clearSegments())
  },
  getNewsForFavorites: () => {
    dispatch(getNewsForFavorites())
  },
  toggleShowBadge: () => {
    dispatch(toggleShowBadge())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CatalogNavBar))
